const config = {
  remotes: {
    backend:  process.env.VUE_APP_BACKEND_URL,
    username: process.env.VUE_APP_BACKEND_USER,
    password: process.env.VUE_APP_BACKEND_PASS,
  },
  new_remotes: {
    url: process.env.VUE_APP_NEW_BACKEND_URL,
  },
  newest_remotes: {
    url: process.env.VUE_APP_NEWEST_BACKEND_URL,
  },
  organithation: {
    url:   process.env.VUE_APP_ORG_URL,
    token: process.env.VUE_APP_ORG_TOKEN,
  },
  address: {
    url:   process.env.VUE_APP_ADDRESS_URL,
    token: process.env.VUE_APP_ADDRESS_TOKEN,
  },
};

export default config;

